import styled from 'styled-components';

import { flexStart } from '../../../../style/reusableStyle';

export const LoginContainer = styled.div`
  width: 100%;
  max-width: 630px;
  margin: 50px auto;
  padding: 10px;
`;

export const ContentContainer = styled.div`
  width: 100%;
  background-color: #f0f0f0;
  padding: 30px;
`;
export const Logo = styled.img``;

export const Label = styled.div`
  margin-left: 10px;
  color: #3d3d3d;
  margin-bottom: 30px;
`;
export const Heading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
`;

export const AlternativeLoginContainer = styled.div`
  width: 100%;
  max-width: 630px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export const AlternativeLogin = styled.div`
  width: 200px;
  ${flexStart}
  gap: 20px;
  color: #3d3d3d;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
